module.exports = __webpack_public_path__ + "img/page.d11c045b.svg";